import React, { ReactNode, useEffect, useState } from 'react';
import { TAuthInfo } from './types/common';

// ログイン状態のContext
export const isLoggedIn = React.createContext<boolean>(false);

export const defaultAuthValue: TAuthInfo | undefined = {
  company_name: '',
  menu: '',
  plan_id: undefined,
  role: undefined,
  user_name: '',
  site_manage_plan_id: 0
};

// 認証情報と認証情報セットのContext
export const AuthInfoContext = React.createContext<
  [
    TAuthInfo | undefined,
    React.Dispatch<React.SetStateAction<TAuthInfo | undefined>>
  ]
  // eslint-disable-next-line @typescript-eslint/no-empty-function
>([defaultAuthValue, () => {}]);

type Props = {
  children: ReactNode;
};

export const AuthContextProvider: React.VFC<Props> = props => {
  const { children } = props;
  // stateの定義
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [authInfo, setAuthInfo] =
    useState<TAuthInfo | undefined>(defaultAuthValue);

  // authInfoのバリデーション
  useEffect(() => {
    // authInfoに正しく値がセットされているかどうかをチェック
    if (authInfo && authInfo.user_name) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, [authInfo]);
  return (
    <isLoggedIn.Provider value={loggedIn}>
      <AuthInfoContext.Provider value={[authInfo, setAuthInfo]}>
        {children}
      </AuthInfoContext.Provider>
    </isLoggedIn.Provider>
  );
};
